import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

const STEP_ITEMS = [
  { value: 4, label: 'پیش نمایش' },
  { value: 0, label: 'در انتظار انجام' },
  { value: 1, label: 'در حال انجام' },
  { value: 2, label: 'انجام شد' },
];

const StatusStepper = ({ state }) => {
  const activeIndex = STEP_ITEMS.findIndex(step => step.value === state);

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          md: 'repeat(4, 1fr)',
        },
        gap: { xs: 1, md: 0 },
        mb: 4,
        p: 1,
        borderRadius: '12px',
        border: '1px solid rgba(0,0,0,0.08)',
        backgroundColor: '#fff',
        boxShadow: '0 1px 2px rgba(0,0,0,0.06)',
      }}
    >
      {STEP_ITEMS.map((item, index) => {
        const isCompleted = activeIndex > index;
        const isCurrent = activeIndex === index;
        const isReached = isCompleted || isCurrent;
        const isLast = index === STEP_ITEMS.length - 1;

        return (
          <Box
            key={item.value}
            sx={{
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              gap: 1.25,
              px: 2,
              py: 1.5,
              borderRadius: '10px',
              backgroundColor: theme =>
                isCurrent
                  ? alpha(theme.palette.brand.blue.primary, 0.08)
                  : 'transparent',
            }}
          >
            <Box
              sx={{
                width: 28,
                height: 28,
                flexShrink: 0,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 12,
                fontWeight: 700,
                color: isReached ? '#fff' : 'brand.grey.ternary',
                backgroundColor: theme =>
                  isCurrent
                    ? theme.palette.brand.orange.primary
                    : isCompleted
                    ? theme.palette.brand.blue.primary
                    : alpha(theme.palette.brand.grey.quaternary, 0.7),
                border: theme =>
                  isReached
                    ? 'none'
                    : `1.5px solid ${theme.palette.brand.grey.quaternary}`,
              }}
            >
              {isCompleted ? (
                <CheckRoundedIcon sx={{ fontSize: 16 }} />
              ) : (
                index + 1
              )}
            </Box>

            <Typography
              sx={{
                fontSize: 13,
                fontWeight: isCurrent ? 700 : 600,
                color: theme =>
                  isCurrent
                    ? theme.palette.brand.blue.primary
                    : isCompleted
                    ? theme.palette.brand.grey.primary
                    : theme.palette.brand.grey.ternary,
                lineHeight: 1.3,
              }}
            >
              {item.label}
            </Typography>

            {!isLast ? (
              <Box
                sx={{
                  display: { xs: 'none', md: 'block' },
                  position: 'absolute',
                  left: 8,
                  top: '50%',
                  width: 16,
                  height: 2,
                  borderRadius: 1,
                  transform: 'translateY(-50%)',
                  backgroundColor: theme =>
                    isCompleted
                      ? theme.palette.brand.blue.primary
                      : alpha(theme.palette.brand.grey.quaternary, 0.9),
                }}
              />
            ) : null}
          </Box>
        );
      })}
    </Box>
  );
};

export default StatusStepper;
